import { api_v2 } from "./api"
import type { LoginResponse } from "../types/auth"

export const authService = {
  login: async (login: string, senha: string): Promise<{ user: LoginResponse; token: string }> => {
    const response = await api_v2.post<{ user: LoginResponse; token: string }>("/mentoria/login", {
      login,
      senha,
    })

    return response.data
  },
}
